import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { VacanciesService } from '../../../core/vacancy/vacancies.service';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { CenterService } from '../../../core/center/center.service';
import { AuthService } from '../../../core/auth/_services/auth.service';
@Component({
  selector: 'create-outside-fg-posting',
  templateUrl: './create-outside-fg-posting.component.html',
  styleUrls: ['./create-outside-fg-posting.component.scss']
})
export class CreateOutsideFGPostingComponent implements OnInit {
  message: any;

  privateHospitalForm: FormGroup;
  profileData: any;
  centers: any;
  imagePath: any;
  outsidePostDetails: any;
  imgURL: any;
  selectedFile: any;
  @BlockUI() blockUI: NgBlockUI;

  constructor(
    private fb: FormBuilder,
    private vacancyService: VacanciesService,
    private centerService: CenterService,
    private auth: AuthService,
    private router: Router
  ) { }

  ngOnInit() {
    this.getAllCenters()
    this.initRecordForm()
    this.profileData = this.getProfileDetails()


  }

  onselect(e) {
    alert(JSON.stringify(e))
  }

  initRecordForm() {
    this.privateHospitalForm = this.fb.group({


      center: [{}, Validators.compose([
        Validators.required

      ]),

      ],
      dateStarted: ["", Validators.compose([
        Validators.required

      ]),


      ],
      file: ["", Validators.compose([
        Validators.required

      ]),


      ],
      fileSource: [""


      ]


    });
  }

  submit() {

    const controls = this.privateHospitalForm.controls;
    /** check form */
    if (this.privateHospitalForm.invalid) {
      Object.keys(controls).forEach(controlName =>
        controls[controlName].markAsTouched()
      );
      return;
    }
    // this.selectedFile = controls.file.value;
    if (this.selectedFile == undefined) {
      Swal.fire(
        'Please upload your posting letter',
        'You must upload your posting letter (Only image format is allowed) ',
        'error'
      )
      return;
    }

    this.blockUI.start('Prcocessing...');
    const recordData = {
      centerId: controls.center.value.id,
      officerId: this.profileData.officerId,
      dateStarted: controls.dateStarted.value,
      letter: this.profileData.email,
      center_name: controls.center.value.center_name
    };

    const formData = new FormData();
    formData.append('file', this.selectedFile, this.selectedFile.name);
    this.auth.uploadBroadFile(formData).subscribe(data => {
      recordData.letter = data.message

      this.centerService.createOutsidePosting(recordData).subscribe(x => {
        this.checkposting();
        this.blockUI.stop()
        this.checkposting();
        Swal.fire(
          'Sent',
          'Record Submitted Successfully ',
          'success'
        )
        this.router.navigateByUrl('/main/dashboard')
      }, error => {
        this.blockUI.stop()
        Swal.fire(
          'record could not be created',
          'Something happened and we could not complete your submission at the moment, please try again later ',
          'error'
        )

      })
    }, error => {
      this.blockUI.stop();
      Swal.fire(
        error,
        'Something happened and we could not send your feedback, please try again later ',
        'error'
      )
    })

  }

  isControlHasError(controlName: string, validationType: string): boolean {
    const control = this.privateHospitalForm.controls[controlName];
    if (!control) {
      return false;
    }

    const result = control.hasError(validationType) && (control.dirty || control.touched);
    return result;
  }

  getProfileDetails() {
    return this.vacancyService.getCurrentUserDetails()
  }

  getAllCenters() {
    this.centerService.getPrivateCenters().subscribe(
      list => {
        let array = list.map(item => {
          return item
        })


        this.centers = array;


      }
    )

  }

  checkposting() {
    this.centerService.checkOusitePosting().subscribe((data) => {

      localStorage.setItem('OutsidePostDetails', JSON.stringify(data))
      this.router.navigateByUrl('main/dashboad');

    }, error => {

    })
  }

  checkOutsidePosting() {
    this.outsidePostDetails = JSON.parse(localStorage.getItem('OutsidePostDetails'))

  }

  onFileChange(event) {


    if (event.target.files.length > 0) {
      const file = event.target.files[0];

      var mimeType = file.type;

      // Allow any image type OR specifically the PDF application type
      const isImage = mimeType.match(/image\/*/) !== null;
      const isPdf = mimeType === 'application/pdf';

      if (!isImage && !isPdf) {
        this.message = "Only image (jpg, png) and PDF files are supported";
        return;
      }
      else {
        if (file.size / 1024 > 1024) {
          this.message = "Image cannot be more than 1MB. the uploaded image is " + file.size / 1024 + "kb in size";
          return;
        }
        this.message = null;
        this.selectedFile = file


      }
    }
  }





}
